import {module as Module} from "modujs";
import {CAROUSEL_DEFAULT_OPTS, CAROUSEL_INSIGHTS_OPTS, CAROUSEL_MIN_OPTS} from "../constants/carousel";
import Splide from "@splidejs/splide";
import {$screen} from "../stores/screen.js";

export default class CarouselGallery extends Module {

    constructor(m) {
        super(m);

        // Binding
        this.onMoveBind = this.onMove.bind(this)

        // UI
        this.$carousel = this.$("main")[0];
        this.$thumbnails = this.$("thumbnails")[0];
        this.$index = this.$("index")[0];

        // Data
        this.splide = null;
        this.type = this.getData('type')
        this.$controls = this.$('controls')[0]
        this.activeIndex = 0
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
        this.initCarousel()
    }

    destroy() {
        super.destroy();
        this.destroyCarousel()
    }

    ///////////////
    // Methods
    ///////////////
    initCarousel() {
        this.main = new Splide( this.$carousel, {
            type      : 'fade',
            rewind    : true,
            pagination: false,
            paginationKeyboard: true
        } );

        this.thumbnails = new Splide( this.$thumbnails, {
            fixedWidth  : 180,
            fixedHeight : 100,
            rewind      : true,
            pagination  : false,
            arrows      : false,
            isNavigation: true,
            focus       : 'center',
            trimSpace   : false,
            updateOnMove: true,
            breakpoints : {
                600: {
                    fixedWidth : 112,
                    fixedHeight: 63,
                },
            },
        } );

        this.main.sync( this.thumbnails );
        this.main.mount();
        this.thumbnails.mount();

        this.main.on( 'moved', this.onMoveBind);
    }

    destroyCarousel() {
        this.main?.destroy(true);
        this.thumbnails?.destroy(true);
    }

    onMove(activeIndex) {
        this.activeIndex = activeIndex;
        this.$index.innerHTML = `${activeIndex + 1}`
    }

    setIndex({index}) {
        this.activeIndex = index;
        this.$index.innerHTML = `${index + 1}`
        this.main?.go( parseInt(index) );
    }
}
